var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"podcast-category container"},[_c('h2',[_vm._v(_vm._s(_vm.category.name))]),_vm._v(" "),_c('div',{staticClass:"block__content"},[_c('div',{staticClass:"row"},_vm._l((_vm.category.categories.items),function(item,index){return _c('Category',{key:index,attrs:{"category":item}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }